import React, {Component} from 'react'
import { compose } from 'recompose'
import WithAjax from '../../common/helpers/WithAjax'
import WithNotify from '../../common/helpers/WithNotify'

class RemoveClientAccount extends Component {
    constructor(props) {
        super(props);
    }

    deleteClienAccount() {
        let url = 'clientaccounts/' + this.props.accountId + '/delete'
        this.props.ajax.put(url, null, null, () => {
          this.props.notify('Client account has been rejected / removed.');
          this.props.onReload();
        })
    }

    render(){
        let buttonText = (this.props.buttonText ? this.props.buttonText : "Remove");

        return (
            <button
				className="btn btn-danger btn-rounded"
				type="button"
				style={{ marginRight: 10 }}
				onClick={() => { if (window.confirm('Are you sure you want to reject / remove this account?')) this.deleteClienAccount(); }}>
				{buttonText}
			</button>
        );
    }
}
export default compose(WithAjax, WithNotify)(RemoveClientAccount)